const addLeadingZero = (value)=>value && value.padStart(2, '0')
;
const toStandardDateFormat = (date)=>{
    if (!date) {
        return undefined;
    }
    const [year, month, day] = date.split('-');
    if (month && day) {
        return `${year}-${addLeadingZero(month)}-${addLeadingZero(day)}`;
    }
};

export { addLeadingZero, toStandardDateFormat };
//# sourceMappingURL=to-standard-date-format.js.map
